import * as stallionActions from '../actions/stallion';
import { CLEAR } from '../actions/filter';

import { putToStorage } from '../utils/localStorageHelper';

const initState = {
    isFetching: false,
    data: [],
    hideResults: true,
    requestFailed: false,

    isFetchingMostFeatured: false,
    mostFeaturedItems: [],
    mostFeaturedRequestFailed: false,
};

export default function stallion(state = initState, action) {
    switch (action.type) {
        case stallionActions.DATA_REQUEST:
            return Object.assign({}, state, {
                isFetching: !action.isSwitcherAction,
                data: action.isSwitcherAction ? state.data : [],
                hideResults: action.isSwitcherAction ? state.hideResults : action.initial,
                requestFailed: false
            });
        case stallionActions.DATA_SUCCESS:
            putToStorage(`results-${action.filterType}`, action.payload.stallion_book);
            return Object.assign({}, state, {
                isFetching: false,
                hideResults: action.isSwitcherAction ? state.hideResults : action.initial,
                requestFailed: false,
                data: action.isSwitcherAction ? state.data :
                action.payload.stallion_book || []
            });
        case stallionActions.DATA_FAILURE:
            return Object.assign({}, state, {
                isFetching: false,
                data: [],
                requestFailed: true
            });

        case stallionActions.MOST_FEATURED_REQUEST:
            return Object.assign({}, state, {
                isFetchingMostFeatured: true,
            });
        case stallionActions.MOST_FEATURED_SUCCESS:
            return Object.assign({}, state, {
                isFetchingMostFeatured: false,
                mostFeaturedItems: action.data,
                requestFailed: false,
            });
        case stallionActions.MOST_FEATURED_FAILURE:
            return Object.assign({}, state, {
                isFetchingMostFeatured: false,
                mostFeaturedRequestFailed: action.error,
            });
        case CLEAR:
            return Object.assign({}, state, {
                hideResults: true
            });
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/client/reducers/stallion.js